function JoinUs() {
    return (
        <>
            JOIN NOW
        </>
    )
}

export default JoinUs